var Handlebars = require("../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return " disabled ";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <input type=\"color\" value=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + "\" data-type=\"color\" data-index=\""
    + alias2(alias1((data && lookupProperty(data,"index")), depth0))
    + "\" />\n    <input type=\"range\" min=\"0\" max=\"1\" step=\"0.1\" value=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"opacity") : depth0), depth0))
    + "\" data-type=\"opacity\" data-index=\""
    + alias2(alias1((data && lookupProperty(data,"index")), depth0))
    + "\" />\n    <div class=\"delete-stop"
    + alias2(alias1((depths[1] != null ? lookupProperty(depths[1],"deleteButtonClass") : depths[1]), depth0))
    + "\">\n        <svg width=\"24\" height=\"24\">\n            <use xlink:href=\"#editor-delete\" data-index=\""
    + alias2(alias1((data && lookupProperty(data,"index")), depth0))
    + "\"></use>\n        </svg>\n    </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<button class=\"btn-primary\" id=\"btn-add-stop\" "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"addStopDisabled") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":46},"end":{"line":1,"column":86}}})) != null ? stack1 : "")
    + ">\n    <icon>\n        <svg>\n            <use xlink:href=\"#editor-plus\"></use>\n        </svg>\n    </icon>\n    <span>"
    + container.escapeExpression(__default(require("../../../../../../../src/utils/handlebars-helpers/t.js")).call(alias1,"tool.gradients.add_new_stop",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":7,"column":10},"end":{"line":7,"column":45}}}))
    + "</span>\n</button>\n\n<div class=\"gradients-editor-stops-list\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"stops") : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":4},"end":{"line":19,"column":13}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true,"useDepths":true});